import { State } from 'src/types'
import { webOfNormalPocket, webTop } from './web'

export const webDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = state.catchFace.color

  webOfNormalPocket(ctx, state.web.color, state.stitch.color)
  webTop(ctx, state.web.color, state.stitch.color)
}
